import { useConsoleView } from '../observability/state'

export function ContextView() {
  const { snapshot } = useConsoleView()

  return (
    <section className="stack" aria-labelledby="context-title">
      <div className="page-heading">
        <div>
          <p className="eyebrow">Operational context</p>
          <h2 id="context-title">Context</h2>
          <p className="muted">Primary and additional instance-local context visible to agents.</p>
        </div>
        <span className="count-badge">{snapshot.contexts.length}</span>
      </div>

      <div className="list-grid">
        {snapshot.contexts.map((entry) => (
          <article className="panel compact-panel" key={entry.id}>
            <div className="section-heading">
              <div>
                <p className="eyebrow">Context #{entry.id}</p>
                <h3>{entry.summary}</h3>
              </div>
              {entry.primary && <span className="chip">primary</span>}
            </div>
            <p className="context-body">{entry.content ?? 'Content hidden in this snapshot.'}</p>
          </article>
        ))}
      </div>

      <article className="panel">
        <div>
          <p className="eyebrow">Communication pressure</p>
          <h3>Alerts and required replies</h3>
        </div>
        <div className="feed">
          {snapshot.communications.map((item) => (
            <div className="feed-row" key={item.name}>
              <div>
                <strong>{item.name}</strong>
                <p className="muted">{item.messagesAwaitingRead} unread · {item.messagesAwaitingReply} reply required</p>
              </div>
              <span className={`count-badge ${item.alertsPending > 0 ? 'count-alert' : ''}`}>{item.alertsPending} alerts</span>
            </div>
          ))}
        </div>
      </article>
    </section>
  )
}
